import React, { lazy, Suspense, useEffect, useState } from "react";
import { Route, Routes } from "react-router-dom";
import AuthProvider from "../src/context/AuthProvider";
import Loader from "./common/Loader";
import InstallPWA from "./PWA/InstallPWA";
import loadApiEndpoints from "./utils/loadApiEndpoints";

const SchoolRoutes = lazy(() => import("../src/routes/SchoolRoutes"));
const ErpRoutes = lazy(() => import("../src/routes/ErpRoutes"));

function App() {
  const [config, setConfig] = useState<null | {
    enquiryUrl: string;
    API_BASE_URL: string;
    schoolErpLanding: boolean;
  }>(null);

  useEffect(() => {
    const fetchEndpoints = async () => {
      try {
        const data = await loadApiEndpoints();
        console.log("Loaded endpoints:", data);
        setConfig(data);
      } catch (error) {
        console.error("Failed to load endpoints:", error);
      }
    };
    fetchEndpoints();
  }, []);

  if (!config) return <Loader />;

  return (
    <>
      <InstallPWA />
      <Suspense fallback={<Loader />}>
        <Routes>
          {/* Home route behavior changes */}
          <Route
            path="/"
            element={
              config.schoolErpLanding ? (
                <AuthProvider>
                  <ErpRoutes />
                </AuthProvider>
              ) : (
                <SchoolRoutes />
              )
            }
          />

          {/* All other routes remain the same */}
          <Route
            path="/school-erp/*"
            element={
              <AuthProvider>
                <ErpRoutes />
              </AuthProvider>
            }
          />
          <Route path="/*" element={<SchoolRoutes />} />
        </Routes>
      </Suspense>
    </>
  );
}

export default App;
